<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <form>
      <div class="vx-row"> 
        <div class="vx-col md:w-1/2 w-full">
          <component
            :baseUrl="baseUrl"
            uploadEndpoint="/uploadFile"
            :is="fName[1].type"
            :structure="fName[1]"
            v-for="(fName) in getDataStructureInChunkForForm[0]"
            :key="fName[0]"
            :value="getMainInfo[fName[0]]"
            :index="fName[0]"
            @input="(data) => inputParams[data.index] = data.value"
            @error="(value) => handleErrors(value)"
          ></component>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <component
            :baseUrl="baseUrl"
            uploadEndpoint="/uploadFile"
            :is="fName[1].type"
            :structure="fName[1]"
            v-for="(fName) in getDataStructureInChunkForForm[1]"
            :key="fName[0]"
            :value="getMainInfo[fName[0]]"
            :index="fName[0]"
            @input="(data) => inputParams[data.index] = data.value"
            @error="(value) => handleErrors(value)"
          ></component>
        </div>
      </div>
    </form>
    {{analyzeFieldStructure}}
    <!-- Permissions -->

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            id="btnSave"
            class="ml-auto mt-2"
            @click="save_changes"
            :disabled="disableSubmitBtn"
          >Save Changes</vs-button>

          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelChanges">Cancel</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { helperMixin } from "../mixin/helperMixin";
import { axiosMixin } from "../mixin/axiosMixin";
import axios from "@/axios.js";

import { withValidation } from "vee-validate";
import aronTextbox from "../components/aron/formElements/textbox";
import aronPassword from "../components/aron/formElements/password";
import aronSelect from "../components/aron/formElements/select";
import aronMultiSelect from "../components/aron/formElements/multiselect";
import aronRadio from "../components/aron/formElements/radio";
import aronRadioStatic from "../components/aron/formElements/radioStatic";
import aronTextarea from "../components/aron/formElements/textArea";
import aronCurrency from "../components/aron/formElements/currency";
import aronNumber from "../components/aron/formElements/number";
import aronDate from "../components/aron/formElements/date";
import aronYearOnly from "../components/aron/formElements/yearOnly";
import aronFile from "../components/aron/formElements/file.vue";
import aronInteger from "../components/aron/formElements/integer";

export default {
  components: {
    aronTextbox,
    aronPassword,
    aronSelect,
    aronMultiSelect,
    aronRadio,
    aronRadioStatic,
    aronTextarea,
    aronCurrency,
    aronNumber,
    aronDate,
    aronYearOnly,
    aronFile,
    aronInteger
  },
  props: {
    endPoint: String,
    addionalData: {
      type: Object,
      default: () => {}
    },
    uploadEndpoint: {
      type: String
    }
  },
  mixins: [helperMixin, axiosMixin],
  data() {
    return {
      inputParams: {},
      errorParams: [],
      disableSubmitBtn: true,
      baseUrl: axios.defaults.baseURL
    };
  },
  computed: {
    ...mapGetters({
      getMainInfo: "profile/getMainInfo",
      getDataStructureInChunkForForm: "profile/getDataStructureInChunkForForm",
      getDataStructureNoChunk: "profile/getDataStructureNoChunk",
      getCallBack: "profile/getCallBack"
    }),

    analyzeFieldStructure() {
      var defaultError = false;
      if (Object.entries(this.getMainInfo).length > 0) {
        defaultError = true;
      }

      for (var data in this.getDataStructureNoChunk) {
        if (data == "password") {
          this.errorParams["password_confirmation"] = defaultError;
        }
        this.errorParams[this.getDataStructureNoChunk[data][0]] = defaultError;
      }
      this.updateSubmitButton();
    },
    operation() {
      return Object.entries(this.getMainInfo).length > 0 ? "update" : "add";
    },
    getUploadEndpoint() {
      return this.uploadEndpoint;
    }
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#btnSave",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#btnSave > .con-vs-loading");
    },
    handleErrors(data) {
      this.errorParams[data.index] = data.value;
      console.log("this.errorParams:", this.errorParams);
      this.updateSubmitButton();
    },
    updateSubmitButton() {
      this.disableSubmitBtn = false;
      for (const id in this.errorParams) {
        if (!this.errorParams[id]) {
          this.disableSubmitBtn = true;
          return false;
        }
      }
    },
    cancelChanges() {
      if (this.operation == "add") {
        this.$emit("cancel", "list");
      } else {
        this.$emit("cancel", "view");
      }
    },
    save_changes() {
      this.startLoading();
 
      console.log("herere:");
      console.log("endPoint:", this.endPoint);
      this.aronPostPut(
        this.endPoint,
        this.operation,
        this.inputParams,
        this.getMainInfo.id
      )
        .then(response => {
          //this.$router.push("/" + this.getCallBack).catch(() => {});
  
          if (this.operation == "add") {
            this.$emit("addnew", {
              response: response.data,
              view: "list"
            });
          } else {
            this.$emit("updateRow", {
              response: response.data,
              view: "view"
            });
          }
          this.stopLoading();
        })
        .catch(error => {
          console.error("error from : update profile_edit. reason:", error);
          this.stopLoading();
        });
    }
  }, 
  created() {
    this.addToObject(this.inputParams, this.addionalData);
  }
};
</script>
